// extracted by mini-css-extract-plugin
export var loadingSpinner = "_3z-1";
export var standaloneTable = "_3z-0";